@use "foundation/_colors.scss";

.pay-invoice-button {
  color: colors.$primary-brand-color;
  cursor: pointer;
  text-decoration: underline;
}

.no-invoices-container {
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: .5em;
  height: 15em;
  margin-top: 2em;

  font-weight: 700;
  background-color: colors.$secondary-background-color;
  color: colors.$secondary-text-color;
}

.invoice-description {
  a {
    text-decoration: underline
  }
}

